// websocket链接的ip
let IP = {};
let host = window.location.host;

// const NODE_ENV = process.env.NODE_ENV;
// if (NODE_ENV == 'development') {
// 	/* IP.fcmsws = '39.106.204.87:20041';
// 	IP.wstest = '39.106.204.87:20041'; */
// 	/* IP.fcmsws = '192.168.25.3:10043';
// 	IP.wstest = '192.168.25.3:10041'; */
// 	// host = '192.168.25.3:10031';
// 	host = '192.168.25.3:10031';
// }

let HTTP = 'ws://';
if (window.location.href.indexOf('https') !== -1) {
	HTTP = 'wss://';
}
const domain = HTTP + host;
IP.wstest = domain + '/uavdata';
IP.fcmsws = domain + '/websocket/info';
IP.fcmsbackws = domain + '/websocket/flightlog';
IP.param = domain + '/websocket/param';
IP.globalws = domain + '/websocket/global';
IP.edu = domain + '/edu';

export default IP;